import { getNewnessByCode } from '../../../../common/EntitiesManagement';
import localize from '../../../../common/localize';
import ReportSectionTitle from '../../../../components/common/ReportSectionTitle';
import TableComponentForReport from './TableComponentForReports';
import ValueOrNoDataLabel from '../../../../components/common/ValueOrNoDataLabel';

export default function ReportNewnessData({ newnessesData }) {
  return (
    <div>
      <ReportSectionTitle title={localize.newnesses} />
      <div className="report_section_without_top_border">
        {newnessesData?.length > 0 ? (
          <TableComponentForReport
            headers={[
              localize.occurr_time,
              localize.description,
              localize.reported_by,
              localize.observations,
            ]}
            rows={newnessesData?.map((newness) => [
              <ValueOrNoDataLabel
                data={new Date(newness.OccurrTime).toLocaleString(undefined, {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit',
                })}
                hideBackground
                centerValue
              />,
              <ValueOrNoDataLabel
                data={
                  newness.AdditionalNewness
                    ? newness.AdditionalNewness.Name
                    : getNewnessByCode(newness.Code)
                }
                hideBackground
                centerValue
              />,
              <ValueOrNoDataLabel
                data={newness.CreatedBy}
                hideBackground
                centerValue
              />,
              <ValueOrNoDataLabel
                data={newness.Observation}
                hideBackground
                centerValue
              />,
            ])}
          />
        ) : (
          <label className="report_little_text">{localize.no_data}</label>
        )}
      </div>
    </div>
  );
}
